import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen.ts";
import { getAccessTokenSync } from "@/utils/storage/authStorage.ts";

// Paths that should restore scroll position when navigating back
// Pattern: /workshops/training or /workshops/webinar (list pages, not detail pages)
const SCROLL_RESTORATION_PATHS_REGEX = /^\/workshops\/[^/]+$/;

export const router = createRouter({
	routeTree,
	context: {
		token: typeof window !== "undefined" ? getAccessTokenSync() : null,
	} as { token: string | null },
	// Enable TanStack Router's built-in scroll restoration
	// This handles scroll timing correctly (after route transition completes)
	scrollRestoration: true,
	defaultPreloadStaleTime: 0,
	// Custom scroll restoration key:
	// - Workshop list pages (/workshops/$type): use pathname to restore scroll when returning from details
	// - All other pages: use unique history key so they always scroll to top on navigation
	getScrollRestorationKey: (location) => {
		if (SCROLL_RESTORATION_PATHS_REGEX.test(location.pathname)) {
			// Workshop list pages: restore scroll position when navigating back
			return location.pathname;
		}
		// All other pages: use unique key so each visit scrolls to top
		return location.state.__TSR_key!;
	},
	// Make scroll restoration instant to avoid visible scroll animation
	scrollRestorationBehavior: "instant",
});

declare module "@tanstack/react-router" {
	interface Register {
		// This infers the type of our router and registers it across your entire project
		router: typeof router;
	}
}

